// src/tab.ts
var Visibility = class {
  constructor() {
    this.subs = [];
    this._isVisible = true;
    document.addEventListener("visibilitychange", () => {
      if (document.visibilityState === "hidden") this.onHidden();
      else this.onVisible(performance.now());
    });
  }
  /** Whether the tab is currently visible */
  get isVisible() {
    return this._isVisible;
  }
  add(subscriber) {
    this.subs.push(subscriber);
  }
  onHidden() {
    this._isVisible = false;
    for (const s of this.subs) s.stop?.();
  }
  onVisible(delta) {
    this._isVisible = true;
    for (const s of this.subs) s.start?.(delta);
  }
};
var Tab = new Visibility();

export { Tab };
//# sourceMappingURL=chunk-MRQ3HZFA.js.map
//# sourceMappingURL=chunk-MRQ3HZFA.js.map